module.exports = __webpack_public_path__ + "static/img/scientific_img_three.7be26756.png";